/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { AssetGallerySectionFragment } from "@cosmos/hygraph-schema";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { cx } from "@panda/css";
import { VStack } from "@panda/jsx";
import { ResponsiveContainer, SectionContainer, SectionHeading, BackgroundContainer } from "@components/elements";
import { AssetGallery } from "./AssetGallery.molecule";

export interface AssetGallerySectionProps extends AssetGallerySectionFragment {
	className?: string;
}

export const AssetGallerySection = ({
	className,
	config,
	assets,
}: AssetGallerySectionProps): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(assets?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack alignItems="stretch" gap="eds.dimension.96" className={cx("asset-gallery-section", className)}>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <AssetGallery assets={assets} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
